module.exports = __webpack_public_path__ + "img/dummy.2911384e.webp";